import { oc } from '@orpc/contract';
import { listCostItemsInputSchema, listCostItemsOutputSchema } from '../schemas/costs.schemas.js';
/** Every recorded cost of one estimate or one stock vehicle, with what each resolves to today. */
export const listCostItemsContract = oc
    .route({
    method: 'GET',
    path: '/costs',
    tags: ['Costs'],
    summary: 'List the cost items of an estimate or a stock vehicle',
})
    .input(listCostItemsInputSchema)
    .output(listCostItemsOutputSchema);
//# sourceMappingURL=list-cost-items.contract.js.map